import gql from 'graphql-tag';
import { ADDRESS_FRAGMENT } from '../fragments/address';
import { CUSTOMER_FRAGMENT } from '../fragments/customer';

/**
 * 获取地址列表
 */
export const fetchActiveCustomerDocument = gql`
  query activeCustomer {
    activeCustomer {
      ...Customer
    }
  }
  ${CUSTOMER_FRAGMENT}
`;

/**
 * 获取地址省市区数据资源
 */
export const fetchRegionsJsonDocument = gql`
  query getRegionsJson($regionNames: [String]!) {
    getRegionsJson(regionNames: $regionNames) {
      value
      text
      children {
        value
        text
        children {
          value
          text
          children {
            value
            text
          }
        }
      }
    }
  }
`;

/**
 * 更新地址
 */
export const fetchUpdateAddressDocument = gql`
  mutation updateCustomerAddress($input: UpdateAddressInput!) {
    updateCustomerAddress(input: $input) {
      ...Address
    }
  }
  ${ADDRESS_FRAGMENT}
`;

/**
 * 创建地址
 */
export const fetchCreateCustomAddressDocument = gql`
  mutation createCustomerAddress($input: CreateAddressInput!) {
    createCustomerAddress(input: $input) {
      ...Address
    }
  }
  ${ADDRESS_FRAGMENT}
`;

/**
 * 删除地址
 */
export const fetchDeleteAddressDocument = gql`
  mutation deleteCustomerAddress($id: ID!) {
    deleteCustomerAddress(id: $id) {
      success
    }
  }
`;
